// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3IO-E","label":"Category_label__2Qc6U","content":"Category_content__1pbkp","header":"Category_header__3o-UT","location":"Category_location__yVvDk"};